import { PropsWithChildren } from 'react';

const IN_TEST = process.env.EXPO_PUBLIC_TEST === 'true';

export const ShowInTest = ({children}: PropsWithChildren) => {
  console.log(IN_TEST, process.env.EXPO_PUBLIC_TEST);
  if (!IN_TEST) {
    return null;
  }
  return children;
};